import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BedSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bedSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedSection' });

  return (
    <section id="hp-bed" className="hp-section bed-section bed">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('bed')} className="clearfix reverse">
          <div className="stack left">
            <div className="flight-bar" />
            <h2>
              {t('title')}
              <span>{t('titleSpan')}</span>
            </h2>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-main">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homepage/bedSection/LEM-Bed-2-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homepage/bedSection/LEM-Bed-2-mob.jpg"
              />
              <img
                data-src="/images/homepage/bedSection/LEM-Bed-2.jpg"
                alt={t('alt')}
                src="/images/homepage/bedSection/LEM-Bed-2.jpg"
                loading="eager"
                decoding="async"
                fetchPriority="low"
                width="960"
                height="700"
              />
            </picture>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BedSection;
